module.exports = __webpack_public_path__ + "static/media/hwseta_headerlogo.38474db9.jpg";